<block-ui class="custom_loader" *ngIf="!error">
    <!-- Bootstrap CSS -->
    <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"
          rel="stylesheet" />
    <div class="container-fluid">
        <div class="row" style="height: 100vh">
            <!-- Image Column -->
            <div class="col-md-6 background-image d-flex">
                <div class="col-12">
                    <div class="pt-4" *ngIf="!isCustomLogo">
                        <img src="../../../../assets/imagesNew/logo_top_left.png" width="200px;" height="200px;" />
                    </div>


                    <div class="col-12 col-md-12 d-flex align-items-center justify-content-center" style="color: white; padding-top: 17rem" *ngIf="!isCustomLogo">
                        <img src="../../../../assets/imagesNew/White_logo_middle.png" width="170px;" height="170px;" />
                        <!--<img  [src]="imageLogoPath" width="170px;" height="170px;" />-->

                       
                    </div>
                    <div class="col-12 col-md-12 d-flex align-items-center justify-content-center" style="color: white; padding-top: 27rem" *ngIf="isCustomLogo">
                        <!--<img src="../../../../assets/imagesNew/keystone.png" width="300px;" height="300px;" />-->
                        <img  [src]="imageLogoPath"  width="300px;" height="300px;" />
                    </div>
                    <div class="col-12 md:col-12 mt-auto d-flex align-items-center justify-content-center">
                        <span style="color: white; padding-top: 7rem">   <img src="../../../../assets/imagesNew/carefinity_v_.png" /> </span><span style="color: white; padding-top: 10rem"> <h4>V{{version}}</h4> </span>
                    </div>
                    <div class="col-12 md:col-12 d-flex align-items-center justify-content-center pt-2"
                         style="color: white">
                        <h5>
                            A Comprehensive EHR Business Continuity & Archiving Solution
                        </h5>
                    </div>
                </div>
            </div>
            <div class="col-md-6 d-flex align-items-center justify-content-center loginBorder"
                 style="padding-top: 200px">
                <table class="col-md-8">
                    <tr>
                        <td>
                            <div class="row mb-2">
                                <div class="col-md-3 col-sm-3 col-lg-3 col-xs-3">&nbsp;</div>
                                <div class="col-md-6 col-sm-6 col-lg-6 col-xs-6">
                                    <h2 style="color: rgb(2, 0, 36); text-align: left"></h2>
                                </div>
                                <div class="col-md-3 col-sm-3 col-lg-3 col-xs-3">&nbsp;</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="pages-panel flex flex-column pb-8 bg-body rounded">
                                <div style="padding-top: 2px">&nbsp;</div>
                                <form [formGroup]="loginForm">
                                    <div class="input-panel flex flex-column px-3">
                                        <div class="inputWithIcon">
                                            <input type="text"
                                                   class="form-control input-lg ml-2"
                                                   placeholder="[Enter User Name ....]"
                                                   formControlName="userName"
                                                   aria-label="Username"
                                                   aria-describedby="addon-wrapping"
                                                   autocomplete="off"
                                                   (ngModelChange)="checkLoginhButtonState()"
                                                   #usernameInput />
                                            <i class="fa fa-lg fa-fw pt-3" aria-hidden="true">
                                                <svg width="25"
                                                     height="25"
                                                     viewBox="0 0 36 38"
                                                     fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18 0C20.3869 0 22.6761 0.998117 24.364 2.77478C26.0518 4.55144 27 6.96111 27 9.47368C27 11.9863 26.0518 14.3959 24.364 16.1726C22.6761 17.9493 20.3869 18.9474 18 18.9474C15.6131 18.9474 13.3239 17.9493 11.636 16.1726C9.94821 14.3959 9 11.9863 9 9.47368C9 6.96111 9.94821 4.55144 11.636 2.77478C13.3239 0.998117 15.6131 0 18 0ZM18 23.6842C27.945 23.6842 36 27.9237 36 33.1579C36 35.774 33.8792 37.8947 31.2632 37.8947H4.73684C2.12076 37.8947 0 35.774 0 33.1579C0 27.9237 8.055 23.6842 18 23.6842Z"
                                                          fill="#232456" />
                                                </svg>
                                            </i>
                                        </div>
                                        <!--<div class="inputWithIcon">
                                            <input type="password"
                                                   id="password"
                                                   formControlName="password"
                                                   placeholder="[Enter Password Here ....]"
                                                   class="form-control input-lg ml-2"
                                                   autocomplete="new-password"
                                                   (ngModelChange)="checkLoginhButtonState()" />
                                            <i class="fa fa-lg fa-fw pt-3" aria-hidden="true">
                                                <svg width="25"
                                                     height="25"
                                                     viewBox="0 0 30 40"
                                                     fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15 30C15.9946 30 16.9484 29.6049 17.6516 28.9016C18.3549 28.1984 18.75 27.2446 18.75 26.25C18.75 25.2554 18.3549 24.3016 17.6516 23.5983C16.9484 22.8951 15.9946 22.5 15 22.5C14.0054 22.5 13.0516 22.8951 12.3484 23.5983C11.6451 24.3016 11.25 25.2554 11.25 26.25C11.25 27.2446 11.6451 28.1984 12.3484 28.9016C13.0516 29.6049 14.0054 30 15 30ZM26.25 13.125C27.2446 13.125 28.1984 13.5201 28.9016 14.2233C29.6049 14.9266 30 15.8804 30 16.875V35.625C30 36.6196 29.6049 37.5734 28.9016 38.2766C28.1984 38.9799 27.2446 39.375 26.25 39.375H3.75C2.75544 39.375 1.80161 38.9799 1.09835 38.2766C0.395088 37.5734 0 36.6196 0 35.625V16.875C0 15.8804 0.395088 14.9266 1.09835 14.2233C1.80161 13.5201 2.75544 13.125 3.75 13.125C4.78553 13.125 5.625 12.2855 5.625 11.25V9.375C5.625 6.8886 6.61272 4.50403 8.37087 2.74587C10.129 0.98772 12.5136 0 15 0C16.2311 0 17.4502 0.242492 18.5877 0.713629C19.7251 1.18477 20.7586 1.87532 21.6291 2.74587C22.4997 3.61642 23.1902 4.64991 23.6614 5.78734C24.1325 6.92477 24.375 8.14386 24.375 9.375V11.25C24.375 12.2855 25.2145 13.125 26.25 13.125ZM15 3.75C13.5082 3.75 12.0774 4.34263 11.0225 5.39752C9.96763 6.45242 9.375 7.88316 9.375 9.375C9.375 11.4461 11.0539 13.125 13.125 13.125H16.875C18.9461 13.125 20.625 11.4461 20.625 9.375C20.625 7.88316 20.0324 6.45242 18.9775 5.39752C17.9226 4.34263 16.4918 3.75 15 3.75Z"
                                                          fill="#232456" />
                                                </svg>
                                            </i>
                                        </div>-->
                                        <div class="inputWithIcon">
                                            <input type="password"
                                                   id="password"
                                                   formControlName="password"
                                                   placeholder="[Enter Password Here ....]"
                                                   class="form-control input-lg ml-2"
                                                   autocomplete="new-password"
                                                   (ngModelChange)="checkLoginhButtonState()"
                                                       [type]="isPasswordVisible? 'text' : 'password'"
                                                   />
                                            <i class="fa fa-lg fa-fw pt-3" aria-hidden="true">
                                                <svg width="25"
                                                     height="25"
                                                     viewBox="0 0 30 40"
                                                     fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15 30C15.9946 30 16.9484 29.6049 17.6516 28.9016C18.3549 28.1984 18.75 27.2446 18.75 26.25C18.75 25.2554 18.3549 24.3016 17.6516 23.5983C16.9484 22.8951 15.9946 22.5 15 22.5C14.0054 22.5 13.0516 22.8951 12.3484 23.5983C11.6451 24.3016 11.25 25.2554 11.25 26.25C11.25 27.2446 11.6451 28.1984 12.3484 28.9016C13.0516 29.6049 14.0054 30 15 30ZM26.25 13.125C27.2446 13.125 28.1984 13.5201 28.9016 14.2233C29.6049 14.9266 30 15.8804 30 16.875V35.625C30 36.6196 29.6049 37.5734 28.9016 38.2766C28.1984 38.9799 27.2446 39.375 26.25 39.375H3.75C2.75544 39.375 1.80161 38.9799 1.09835 38.2766C0.395088 37.5734 0 36.6196 0 35.625V16.875C0 15.8804 0.395088 14.9266 1.09835 14.2233C1.80161 13.5201 2.75544 13.125 3.75 13.125C4.78553 13.125 5.625 12.2855 5.625 11.25V9.375C5.625 6.8886 6.61272 4.50403 8.37087 2.74587C10.129 0.98772 12.5136 0 15 0C16.2311 0 17.4502 0.242492 18.5877 0.713629C19.7251 1.18477 20.7586 1.87532 21.6291 2.74587C22.4997 3.61642 23.1902 4.64991 23.6614 5.78734C24.1325 6.92477 24.375 8.14386 24.375 9.375V11.25C24.375 12.2855 25.2145 13.125 26.25 13.125ZM15 3.75C13.5082 3.75 12.0774 4.34263 11.0225 5.39752C9.96763 6.45242 9.375 7.88316 9.375 9.375C9.375 11.4461 11.0539 13.125 13.125 13.125H16.875C18.9461 13.125 20.625 11.4461 20.625 9.375C20.625 7.88316 20.0324 6.45242 18.9775 5.39752C17.9226 4.34263 16.4918 3.75 15 3.75Z"
                                                          fill="#232456" />
                                                </svg>
                                            </i><span><i (click)="togglePasswordVisibility()" [class]="isPasswordVisible? 'fa fa-eye-slash fa-lg fa-fw pl_eye_96' : 'fa fa-eye fa-lg fa-fw pl_eye_96'" style="cursor: pointer;" title="Click to view masked text"  aria-hidden="true">
       
    </i>
</span>
                                        </div>
                                        <div class="d-grid gap-2"
                                             style="padding: 10px 20px 10px 10px">
                                            <button class="btn form-control loginbutton"
                                                    (click)="onLogin()"
                                                    [disabled]="loginhButtonDisabled">
                                                LOGIN
                                            </button>
                                        </div>
                                        <div class="col-12" *ngIf="isInvalidCredentials">
                                            <span style="float: right;font-size: medium;font-family: Arial, Helvetica, sans-serif;color: #10124c;text-decoration: underline;">
                                                <strong>
                                                    <a href="javascript:void(0)" (click)="onForgot()">Forgot Password?</a>
                                                </strong>
                                            </span>
                                        </div>
                                        <div class="col-12 pl-2 pr-0" *ngIf="isInvalidCredentials">
                                            <div style="text-align: center; background-color: #f5dcdf"
                                                 class="p-message p-message-error pt-2 pb-2">
                                                Invalid Username or Password.  <br>
                                                You have a few more attempts remaining. Please try again or click Forget Password.
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class=""></div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="d-flex flex-column align-items-center justify-content-center">
                                <div style="">
                                    <img src="../../../../assets/imagesNew/CareFinityGroup.png"
                                         alt=""
                                         style="width: 1000px" />
                                </div>

                                <div class="container text-center my-5">
                                    <div class="row">
                                        <div class="col">
                                            <b>Copyright © {{ copyrightDate }}</b>, All rights reserved. <b>|</b>
                                            <a href="https://medtechsolutions.com/legal/privacy-policy/"
                                               target="_blank"
                                               title="View Privacy Policy">
                                                <b>Privacy Policy</b>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</block-ui>

<p-dialog header="Confirm"
          [(visible)]="isAlreadyLoggedInPopUp"
          [modal]="true"
          [responsive]="true"
          [style]="{ width: '500px', minWidth: '250px' }"
          [minY]="100"
          [maximizable]="false"
          [baseZIndex]="10000">
    <div class="p-fluid formgrid grid">
        <div class="col-12 pb-3" style="text-align: center">
            <img src="/../../../assets/imagesNew/active.png"
                 alt="Warning Icon"
                 style="width: 284px; height: 284px" />
        </div>
        <div class="field col-12 md:col-12"
             style="text-align: center; font-size: 12px; font-weight: 500">
            You already have an active session on the server. You can end the existing
            session and start a new one, which may end the session of any other
            logged-in user.
            <hr class="mb-0" />
        </div>

        <div style="display: flex; justify-content: center" class="col-12">
            <div class="field col-4 md:col-6 mr-2 mb-0">
                <button pButton
                        type="button"
                        icon="pi pi-check"
                        label="End Session"
                        class="p-button-plain"
                        (click)="endSession()"></button>
            </div>
            <div class="field col-4 md:col-6 mb-0">
                <button pButton
                        type="button"
                        icon="pi pi-check"
                        label="Cancel"
                        (click)="isAlreadyLoggedInPopUp = false"
                        class="p-button-plain GreyButton buttonWidth-8"
                        severity="secondary"></button>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog header="Confirm"
          [(visible)]="isAlreadyLoggedInPopUpWithoutOptionToEnd"
          [modal]="true"
          [responsive]="true"
          [style]="{ width: '450px', minWidth: '200px' }"
          [minY]="100"
          [maximizable]="false"
          [baseZIndex]="10000">
    <div class="card">
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12">
                You already have an active session on the server. Terminate the session
                and try again.
            </div>

            <div class="field col-12 md:col-6">
                <button pButton
                        type="button"
                        icon="pi pi-check"
                        label="Cancel"
                        (click)="isAlreadyLoggedInPopUpWithoutOptionToEnd = false"
                        class="p-button-plain"></button>
            </div>
        </div>
    </div>
</p-dialog>

<div *ngIf="error"
     style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
    padding-top: 200px;
  ">
    <div *ngIf="error"
         style="
      height: 100%;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    ">
        <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
      ">
            <div style="
          background-color: #f8d7da;
          color: #721c24;
          padding: 20px;
          border: 1px solid #f5c6cb;
          border-radius: 5px;
          text-align: center;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        ">
                There was a problem connecting to the server. You can try refreshing
                this page. If the problem persists, please contact support.
            </div>
        </div>
    </div>
</div>



